

















































































































































import {Component, Vue, Prop, PropSync, Watch, Emit} from 'vue-property-decorator';
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxDropDownBox } from 'devextreme-vue/drop-down-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import {
  EcoFilialSelectionType,
  EcoNodeSelectionType,
  GroupedObjects,
  SelectedGroupedObjects
} from '@/services/models-service';
import { numeralForm } from '@/utils/numbers';



@Component({
  name: 'TreeDropDownBox',
  components: {
    DxScrollView,
    DxDropDownBox,
    DxCheckBox,
  }
})
export default class extends Vue {
  @PropSync('selection') public selectionBlock: EcoFilialSelectionType[];
  @PropSync('grouped', {default: () => []}) public gropedObjects: SelectedGroupedObjects[];
  @PropSync('selectAll', {default: false}) public checkAllFilials: boolean;
  @Prop() public title!: string;
  @Prop({default: false}) public disabled!: boolean;
  @Prop({default: false}) public showFacility!: boolean;
  @Prop({default: false}) public enableSelectAllCheckbox!: boolean;
  @Prop({default: false}) public oneActiveCheck!: boolean;


   onRightClickFacility(filialId: number, nodeId: number) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    const node = filial?.nodes.find(n => n.id === nodeId);
    console.log("node", node)
    if (!node) return;

    // выбираем родителя (node)
    if(node.check === true){
      this.onNodeCheckChanged(filialId, nodeId, { value: false })
    } else {
      this.onNodeCheckChanged(filialId, nodeId, { value: true });
    }
    
  }

  private onRightClickNode(filialId: number) {
  const filial = this.selectionBlock.find(f => f.id === filialId);
  if (!filial) return;

  // выбираем родителя (filial)
  if(filial.check === true){
      this.onFilialCheckChanged(filialId, { value: false });
    } else {
      this.onFilialCheckChanged(filialId, { value: true });
    }
  }

  private onRightClickFilial(filialId: number) {
    if (this.selectAllCheckbox){
      this.onAllSelectionChanged({value: false})
    } else {
      this.onAllSelectionChanged({value: true})
    }
  }
  private selectedNodes: number[] = [];
  private selectedObjects: number[] = [];
  private selectAllCheckbox = false;
  private expandedFilials: { [id: number]: boolean } = {};
  private expandedNodes: { [key: string]: boolean } = {};
  private isGroupedExpanded: boolean = true;



  private onDropDownValueChanged(e: any) {
    if (e.value === null) {
      this.clearAllSelections();
    }
  }



  private clearAllSelections() {
    this.selectionBlock.forEach(filial => {
      filial.check = false;
      filial.nodes.forEach(node => {
        node.check = false;
        if (node.facilities) {
          node.facilities.forEach(facility => facility.check = false);
        }
      });
    });
    
    this.gropedObjects.forEach(obj => obj.check = false);
    this.selectAllCheckbox = false;
    this.checkAllFilials = false;
    
    this.emitChanges();
  }



  private nodeKey(filialId: number, nodeId: number) {
    return filialId + ':' + nodeId;
  }



  private toggleGroupedSection() {
    this.isGroupedExpanded = !this.isGroupedExpanded;
  }



  isFilialExpanded(filialId: number) {
    return !!this.expandedFilials[filialId];
  }
  
  isNodeExpanded(filialId: number, nodeId: number) {
    return !!this.expandedNodes[this.nodeKey(filialId, nodeId)];
  }



  toggleFilial(filialId: number) {
    this.$set(this.expandedFilials, filialId, !this.isFilialExpanded(filialId));
  }
  
  toggleNode(filialId: number, nodeId: number) {
    const k = this.nodeKey(filialId, nodeId);
    this.$set(this.expandedNodes, k, !this.expandedNodes[k]);
  }



  mounted() {
    this.ensureExpandKeys(true);
    this.sortFacilitiesTree();
  }



  private ensureExpandKeys(defaultExpanded: boolean) {
    (this.selectionBlock || []).forEach(f => {
      if (typeof this.expandedFilials[f.id] === 'undefined') {
        this.$set(this.expandedFilials, f.id, defaultExpanded);
      }
      (f.nodes || []).forEach(n => {
        const k = this.nodeKey(f.id, n.id);
        if (typeof this.expandedNodes[k] === 'undefined') {
          this.$set(this.expandedNodes, k, defaultExpanded);
        }
      });
    });
  }



  // ============= ОБРАБОТЧИКИ ИЗМЕНЕНИЙ =============



  onAllSelectionChanged(e: any) {
    const newValue = e.value;
    this.selectionBlock.forEach(filial => {
      this.setFilialCheckDirect(filial, newValue);
    });
    this.selectAllCheckbox = newValue;
    this.emitChanges();
  }



  onFilialCheckChanged(filialId: number, e: any) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;



    const newValue = e.value;
    if( newValue !== null) {
      this.setFilialCheckDirect(filial, newValue);
    }
    
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }



  onNodeCheckChanged(filialId: number, nodeId: number, e: any) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;


    const node = filial.nodes.find(n => n.id === nodeId);
    if (!node) return;


    const newValue = e.value;
    if( newValue !== null) {
      this.setNodeCheckDirect(node, newValue);
    }
    
    this.updateFilialCheckFromNodes(filial);
    
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }



  onFacilityCheckChanged(filialId: number, nodeId: number, facilityId: number, e: any) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;



    const node = filial.nodes.find(n => n.id === nodeId);
    if (!node || !node.facilities) return;



    const facility = node.facilities.find(f => f.id === facilityId);
    if (!facility) return;



    facility.check = e.value;
    
    // Пересчитываем узел на основе объектов
    this.updateNodeCheckFromFacilities(node);
    
    // Пересчитываем филиал на основе узлов
    this.updateFilialCheckFromNodes(filial);
    
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }



  onGroupedObjectChanged(id: string, e: any) {
    const o = this.gropedObjects.find(f => f.id === id);
    if (o) {
      o.check = e.value;
    }
  }



  // ============= ВСПОМОГАТЕЛЬНЫЕ МЕТОДЫ =============



  /**
   * Установить чек филиала И КАС­КАД­НО все узлы и объекты
   * Используется при клике пользователя на чекбокс филиала
   */
  private setFilialCheckDirect(filial: any, value: boolean) {
    filial.check = value;
    filial.nodes.forEach((node: any) => {
      this.setNodeCheckDirect(node, value);
    });
  }



  /**
   * Установить чек узла И все его объекты
   * Используется при клике пользователя на чекбокс узла или при каскадном изменении от филиала
   */
  private setNodeCheckDirect(node: any, value: boolean) {
    node.check = value;
    if (this.showFacility && node.facilities) {
      node.facilities.forEach((facility: any) => {
        facility.check = value;
      });
    }
  }



  /**
   * Пересчитать состояние узла на основе его объектов
   * true - все выбраны
   * false - ничего не выбрано
   * null - частичный выбор
   */
  private updateNodeCheckFromFacilities(node: any) {
    if (!node.facilities || node.facilities.length === 0) {
      return;
    }



    const checkedCount = node.facilities.filter((f: any) => f.check === true).length;
    const uncheckedCount = node.facilities.filter((f: any) => f.check === false).length;
    const totalCount = node.facilities.length;



    if (checkedCount === totalCount) {
      node.check = true;
    } else if (uncheckedCount === totalCount) {
      node.check = false;
    } else {
      node.check = null;
    }
  }



  /**
   * Пересчитать состояние филиала на основе его узлов
   * true - все узлы выбраны полностью
   * false - все узлы НЕ выбраны и нет частичных
   * null - есть выбранные и не выбранные узлы ИЛИ есть частично выбранные узлы
   */
  private updateFilialCheckFromNodes(filial: any) {
    if (!filial.nodes || filial.nodes.length === 0) {
      return;
    }


    const fullCheckedCount = filial.nodes.filter((n: any) => n.check === true).length;
    const partialCount = filial.nodes.filter((n: any) => n.check === null).length;
    const uncheckedCount = filial.nodes.filter((n: any) => n.check === false).length;
    const totalCount = filial.nodes.length;


    // Все узлы полностью выбраны
    if (fullCheckedCount === totalCount) {
      filial.check = true;
    }
    // Ни один узел не выбран
    else if (uncheckedCount === totalCount) {
      filial.check = false;
    }
    // Есть хотя бы один частично выбранный узел
    else if (partialCount > 0) {
      filial.check = null;
    }
    // Есть и выбранные, и невыбранные узлы (но нет частичных)
    else if (fullCheckedCount > 0 && uncheckedCount > 0) {
      filial.check = null;
    }
    // На всякий случай (не должно быть)
    else {
      filial.check = false;
    }
  }



  private updateSelectAllCheckbox() {
    if (!this.enableSelectAllCheckbox) return;



    const allChecked = this.selectionBlock.every(f => f.check === true);
    this.selectAllCheckbox = allChecked;
  }



  private emitChanges() {
    const filials: number[] = [];
    const nodes: number[] = [];
    const facilities: number[] = [];



    this.selectionBlock.forEach(filial => {
      if (filial.check === true) {
        filials.push(filial.id);
        filial.nodes.forEach(node => {
          nodes.push(node.id);
          if (this.showFacility && node.facilities) {
            facilities.push(...node.facilities.map(f => f.id));
          }
        });
      } else {
        filial.nodes.forEach(node => {
          if (node.check === true) {
            nodes.push(node.id);
            if (this.showFacility && node.facilities) {
              facilities.push(...node.facilities.map(f => f.id));
            }
          } else if (this.showFacility && node.facilities) {
            const checkedFacilities = node.facilities.filter(f => f.check === true);
            facilities.push(...checkedFacilities.map(f => f.id));
          }
        });
      }
    });



    this.emitHierarchy({ filials, nodes, facilities });
  }



  @Emit('selection-hierarchy-changed')
  private emitHierarchy(payload: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }): {
    filials: number[];
    nodes: number[];
    facilities: number[];
  } {
    return payload;
  }



  @Emit('selection-grouped-objects-changed')
  private emitGroupedObjects(groupedObjects: string[]): string[] {
    return groupedObjects;
  }



  @Watch('gropedObjects', { deep: true })
  private onGroupedObjectsChanged() {
    const gropedObjects = new Set<string>();
    this.gropedObjects.forEach(sb => {
      if (sb.check) {
        gropedObjects.add(sb.id);
      }
    });
    this.emitGroupedObjects(Array.from(gropedObjects));
  }



  @Watch('selectionBlock', { deep: true })
  private onHierarchyChanged() {
    this.ensureExpandKeys(false);
  }



  get displayValue(): string[] | null {
    let filials: any[] = [];
    let selectedNodes: any[] = [];
    let selectedObjects: number[] = [];



    for (const filial of this.selectionBlock) {
      if (filial.check === true) {
        filials.push(filial.name);
        for (const n of filial.nodes) {
          selectedNodes.push(n.id);
          if (this.showFacility && n.facilities) {
            selectedObjects.push(...n.facilities.map((f): number => f.id));
          }
        }
      } else {
        let nodes: number[] = [];
        let selectedObjCount = 0;
        
        for (const n of filial.nodes) {
          if (n.check === true) {
            nodes.push(n.id);
            if (this.showFacility && n.facilities) {
              selectedObjects.push(...n.facilities.map((f): number => f.id));
            }
          } else if (this.showFacility && n.facilities) {
            const facilitiesSelectedInNode = n.facilities.filter(f => f.check).map((f): number => f.id);
            selectedObjCount += facilitiesSelectedInNode.length;
            selectedObjects = [...selectedObjects, ...facilitiesSelectedInNode];
          }
        }
        
        if (nodes.length) {
          filials.push(`${filial.name} (${nodes.length} ТУ)`);
          selectedNodes = [...selectedNodes, ...nodes];
        } else if (this.showFacility && selectedObjCount > 0) {
          filials.push(`${filial.name} (${selectedObjCount} ${numeralForm(selectedObjCount, ['объект', 'объекта', 'объектов'])} ТУ)`);
        }
      }
    }



    this.selectedNodes = selectedNodes;
    if (this.showFacility) {
      this.selectedObjects = selectedObjects;
    }



    let groupCounter = 0;
    for (const el of this.gropedObjects) {
      if (el.check) {
        groupCounter += 1;
      }
    }



    if (groupCounter > 0) {
      filials.push(`Групповых объектов (${groupCounter})`);
    }



    return filials;
  }



  private facilityComparator(a: any, b: any) {
    const priorityOrder = [25, 29, 30];
    const rank = (x: any) => {
      const id = Number(x?.object_type_id);
      const idx = priorityOrder.indexOf(id);
      return idx === -1 ? priorityOrder.length : idx;
    };



    const ra = rank(a);
    const rb = rank(b);
    if (ra !== rb) return ra - rb;



    const an = (a?.name ?? '').toString();
    const bn = (b?.name ?? '').toString();
    return an.localeCompare(bn, 'ru', { sensitivity: 'base', numeric: true });
  }



  private sortFacilitiesTree() {
    (this.selectionBlock || []).forEach(f => {
      (f?.nodes || []).forEach((n: any) => {
        if (Array.isArray(n?.facilities)) {
          n.facilities.sort((x: any, y: any) => this.facilityComparator(x, y));
        }
      });
    });
  }



  @Watch('selectionBlock', { immediate: true })
  private onSelectionReplaced(newVal: EcoFilialSelectionType[], oldVal: EcoFilialSelectionType[]) {
    if (!Array.isArray(this.selectionBlock)) return;
    this.sortFacilitiesTree();
    this.ensureExpandKeys(false);
  }
}
